export default {
  common: {
    ok: '确定',
    cancel: '取消'
  },
  ticketlessSeletion: {
    serviceDay: '搭乘日',
    serviceDayTips: '点击“开始使用”后，将无法更改乘车日期。',
    serviceTime: '搭乘时间',
    stationSelect: '选择上下车车站',
    startStationSelect: '请选择上车车站',
    arriveStationSelect: '请选择下车车站',
    returnToTicketList: '返回票券列表',
    toSeatSelect: '前往座位选择',
    currentTicketInfo: '目前的车票信息',
    serviceTrain: '列车信息',
    boughtNum: '购买数量',
    adult: '成人{{num}} 人',
    child: '儿童{{num}} 人',
    seatNo: '{{carNo}}号车{{seatNo}}号',
    allSeatNeedBeSelected: '※须重新选择所有座位。',
    mustSelectArriveStation: '请选择下车车站',
    mustSelectStartStation: '请选择上车车站',
    mustPickServiceDate: '请选择搭乘日期',
    mustPickServiceTime: '请选择搭乘时间',
    serviceDate: '{{year}}年{{month}}月{{date}}日',
    seat: '座位',
    paramsError: '参数无效',
    confirmSelectSeat: `【请注意】
您将被重定向到外部站点，请勿点击浏览器的返回按钮或使用历史记录跳转功能，并请避免同时在多个浏览器标签或视窗中进行操作。`
  },
  ticketlessSeletionCallback: {
    paramExpVoucherError: 'ExpVoucher参数错误',
    pleaseWait: '处理中，请稍候。',
    decryptFailedMsg:
      '发生错误，请回到首页确认您的座位信息。若无法选位，请再次尝试。'
  },
  ticketlessSeletionAbort: {
    paramExpVoucherError: 'ExpVoucher参数错误',
    tips: '座位选择处理过程中断'
  }
};
